export default __webpack_public_path__ + "static/media/parking.42d6e424.png";